module.exports = __webpack_public_path__ + "static/media/sigma.97d45286.svg";